const PLURAL_FORMULA_EN = (n: number) => Number(n !== 1);

const PLURALS_EN = ['', 's'];

export const pluralize = (word: string, n: number) => {
  return `${word}${PLURALS_EN[PLURAL_FORMULA_EN(n)]}`;
};
